import { RDate, makeImmutable } from "../../core";
import { Availability } from "../Availability";
/**
 * Information that the orrder should be fulfilled on a specified hour.
 */
export class OnTimeFulfillmentTime {
    constructor(params) {
        this.type = "OnTime";
        this.date = params.date;
        this._label = params.label;
        makeImmutable(this);
    }
    static fromStorageData(params) {
        const date = RDate.fromString(params.storageData.date, params.storageData.tz);
        if (date.isBefore(params.now)) {
            // NOTICE Past dates are invalid
            return null;
        }
        return new OnTimeFulfillmentTime({
            date,
            label: params.storageData.label,
        });
    }
    get label() {
        return this._label !== null ? this._label : "";
    }
    get availability() {
        return Availability.boolean({
            InvalidDate: !this.date.isValid,
        });
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        return this.date.toString;
    }
    get storageData() {
        return {
            type: "OnTime",
            label: this.label,
            date: this.date.toString,
            tz: this.date.tz,
        };
    }
}
